import { combineReducers } from 'redux'
import {
  UPDATE_SOMETHING
} from "./action-types.js"; 
//import { Object } from "core-js";

const initialState = {
};

const sharedReducer = (state = initialState, action) => {
  switch (action.type) {

    case UPDATE_SOMETHING:
      return { ...state, ...action.data };
    default:
      return { ...state };
  }
};

export default sharedReducer;